import type { PeriodOption } from './types';

export const PERIOD_OPTIONS: { value: PeriodOption; label: string }[] = [
  { value: 'Últimos 3M', label: 'Últimos 3 meses' },
  { value: 'Últimos 6M', label: 'Últimos 6 meses' },
  { value: 'Últimos 12M', label: 'Últimos 12 meses' },
  { value: 'Últimos 18M', label: 'Últimos 18 meses' },
  { value: 'Últimos 24M', label: 'Últimos 24 meses' },
];

export const PERIOD_MONTHS_MAP: Record<PeriodOption, number> = {
  'Últimos 3M': 3,
  'Últimos 6M': 6,
  'Últimos 12M': 12,
  'Últimos 18M': 18,
  'Últimos 24M': 24,
};

export const DEFAULT_PERIOD: PeriodOption = 'Últimos 24M';

export type MonthTableShortcut = '' | '3' | '6' | '12' | '18' | '24';

export const MONTH_TABLE_OPTIONS: {
  value: MonthTableShortcut;
  label: string;
}[] = [
  { value: '3', label: 'Últimos 3 meses' },
  { value: '6', label: 'Últimos 6 meses' },
  { value: '12', label: 'Últimos 12 meses' },
  { value: '18', label: 'Últimos 18 meses' },
  { value: '24', label: 'Últimos 24 meses' },
];
